var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, AccordionDetails as MuiAccordionDetails, } from '@mui/material';
import { ChevronDownIcon } from '@localina/icons';
import { Label } from '../Label';
export var Accordion = function (props) {
    var _a;
    var className = 'localina-accordion';
    var collapsible = (_a = props.collapsible) !== null && _a !== void 0 ? _a : true;
    var _b = React.useState(Boolean(props.defaultExpanded)), expanded = _b[0], setExpanded = _b[1];
    return (_jsxs(MuiAccordion, __assign({ className: className, square: true, expanded: collapsible ? expanded : true, onChange: function (_, isExpanded) { return collapsible && setExpanded(isExpanded); } }, { children: [_jsx(MuiAccordionSummary, __assign({ className: "".concat(className, "__summary"), expandIcon: collapsible ? _jsx(ChevronDownIcon, {}) : undefined, sx: collapsible ? undefined : { cursor: 'default' } }, { children: _jsx(Label, { type: "title", variant: "h6", value: props.title }) })), _jsx(MuiAccordionDetails, __assign({ className: "".concat(className, "__details") }, { children: props.children }))] })));
};
